export default "__VITE_ASSET__wp78BNVw__"